import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { TrashBaseIcon } from '@tableau/icons/TrashBaseIcon';
import React from 'react';

import { isPhoneSizedScreenOrUserProbablyOnMobile } from '~src/commonInfra/utils/MobileHelper';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { discardDraftRequestedAction } from '../../drafts/actions/DiscardDraftAction';
import { DraftBanner, DraftBannerAction } from '../../drafts/components/DraftBanner';
import { DraftWorkbookSpaceProps } from '../../drafts/types/DraftsTypes';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';
import { editWorkbookDraft } from '../actions/EditWorkbookAction';

export type WorkbookSpaceHeaderDraftBannerProps = {
  readonly draftInfo: DraftWorkbookSpaceProps;
  readonly workbookContent: ISpaceItemDetailInfo<'workbook'>;
};

export function WorkbookSpaceHeaderDraftBanner(props: WorkbookSpaceHeaderDraftBannerProps): JSX.Element {
  const handleEditDraft = () => {
    if (props.workbookContent) {
      getAppStore().dispatch(editWorkbookDraft(props.workbookContent, 'DraftBanner_ContinueEditing'));
    }
  };

  const handleDiscardDraft = () => {
    let content = props.workbookContent;
    getAppStore().dispatch(discardDraftRequestedAction({
      draftLuid: props.draftInfo.draftLuid,
      contentType: content.contentType,
      parentLuid: content.luid,
      name: content.name,
      locationOrigin: 'DraftBanner_DiscardChanges'
    }));
  };

  const draftBannerActions: DraftBannerAction[] = [];

  if (!isPhoneSizedScreenOrUserProbablyOnMobile()) {
    draftBannerActions.push({
      label: Messages.continueEditing(),
      handleAction: handleEditDraft,
      icon: <PencilBaseIcon size={18} aria-hidden={true}/>,
      testId: 'continue-editing'
    });
  }

  draftBannerActions.push({
    label: Messages.deleteDraft(),
    handleAction: handleDiscardDraft,
    icon: <TrashBaseIcon size={14} aria-hidden={true}/>,
    testId: 'discard-changes'
  });

  return (
    <DraftBanner
      lastEditDate={props.draftInfo.draftUpdatedAt}
      draftBannerActions={draftBannerActions}
      contentTypeName={Messages.lastEditedWorkbookDraft()}
    />
  );
}
